import { render, staticRenderFns } from "./UpdateField.vue?vue&type=template&id=1024fa56"
import script from "./UpdateField.vue?vue&type=script&lang=js"
export * from "./UpdateField.vue?vue&type=script&lang=js"
import style0 from "./UpdateField.vue?vue&type=style&index=0&id=1024fa56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports